import { render } from "./CheckoutView.vue?vue&type=template&id=2dfc7cb2"
import script from "./CheckoutView.vue?vue&type=script&lang=js"
export * from "./CheckoutView.vue?vue&type=script&lang=js"

import "./CheckoutView.vue?vue&type=style&index=0&id=2dfc7cb2&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__